import { resolveAssetUrl } from '@/utils/assetUrl';

/**
 * Placeholder avatar paths for different user roles.
 * These will be used as fallbacks when no real photo is available.
 * Once full image-upload functionality is built, these will only
 * serve as defaults for users who haven't uploaded a picture yet.
 */

export const AVATAR_ADMIN = '/avatar-admin.png';
export const AVATAR_STUDENT = '/avatar-student.png';
export const AVATAR_TEACHER = '/avatar-teacher.png';

/**
 * Returns the appropriate placeholder avatar path based on role.
 * Falls back to admin avatar if the role is unrecognised.
 */
export function getPlaceholderAvatar(role: 'admin' | 'teacher' | 'student' | string): string {
  switch (role.toLowerCase()) {
    case 'student':
      return AVATAR_STUDENT;
    case 'teacher':
      return AVATAR_TEACHER;
    case 'admin':
    default:
      return AVATAR_ADMIN;
  }
}

export type PersonPhotoSource = {
  photo?: string | null;
  image?: string | null;
};

/**
 * Resolves a user's photo URL.
 * Attendance payloads use `image`; records use `photo`. Both are the same file.
 * ui-avatars.com URLs are treated as "no real photo".
 */
export function resolveUserPhoto(
  photo: string | null | undefined,
  role: 'admin' | 'teacher' | 'student'
): string {
  if (!photo || photo.includes('ui-avatars.com')) {
    return getPlaceholderAvatar(role);
  }
  return resolveAssetUrl(photo) || photo;
}

export function resolvePersonPhoto(
  source: PersonPhotoSource | string | null | undefined,
  role: 'admin' | 'teacher' | 'student'
): string {
  if (typeof source === 'string' || source == null) {
    return resolveUserPhoto(source, role);
  }
  return resolveUserPhoto(source.photo || source.image, role);
}
